import * as yup from "yup";
export const CreateFarmTrainingMediaSchema = yup.object().shape({
    trainingDate: yup.string().required("Please select a month"),
  uploadImage: yup
    .array()
    .of(yup.mixed())
    .min(1, "Please upload at least one file")
    .required("Please upload at least one file"), 
});
